import { ContactCornSchema } from '@eigtech/contacts-types';
import { EventBaseSchema, eventType } from '@eigtech/event-stream-types';
import { z } from 'zod';
const tplapServiceName = 'tplap';
const tplapServiceEventType = (entity, eventName) => eventType(tplapServiceName, entity, eventName);
const TplapServiceEventBaseSchema = EventBaseSchema.merge(z.object({
    type: tplapServiceEventType(),
}));
const tplapPortalEventType = (eventName) => tplapServiceEventType('portal', eventName);
export const DeprecatedTplapPortalStatusSchema = z.enum(['ACTIVE', 'INACTIVE', 'ACTIVATING']);
export const DEPRECATED_TPLAP_PORTAL_STATUS = DeprecatedTplapPortalStatusSchema.enum;
export const DeprecatedTplapPortalSchema = z.object({
    auth0Id: z.string(),
    contactId: ContactCornSchema,
    claimNumber: z.string(),
    dateCreated: z.string().datetime(),
    dateModified: z.string().datetime(),
    createdBy: z.string(),
    modifiedBy: z.string(),
    status: DeprecatedTplapPortalStatusSchema,
});
export const DeprecatedTplapPortalEventSchema = TplapServiceEventBaseSchema.merge(z.object({
    type: tplapPortalEventType(),
    portal: DeprecatedTplapPortalSchema,
}));
export const DeprecatedTplapPortalActivatedEventSchema = DeprecatedTplapPortalEventSchema.merge(z.object({
    type: tplapPortalEventType('activated'),
}));
export const DeprecatedTplapPortalDeactivatedEventSchema = DeprecatedTplapPortalEventSchema.merge(z.object({
    type: tplapPortalEventType('deactivated'),
}));
export const isDeprecatedTplapPortalEvent = (event) => DeprecatedTplapPortalEventSchema.safeParse(event).success;
